import { RealmAsset, RealmAssetLocationType } from "realmforge-common";
import { getAssetFileName } from "realmforge-lib";

/**
 * Gets the url path for an asset of a realm blueprint
 */
export const getRealmBlueprintAssetPath = (asset: RealmAsset) => {
  const fileName = getAssetFileName(asset);
  return asset.location === RealmAssetLocationType.Local
    ? `/assets/realms/assets/${fileName}`
    : asset.remoteSrc;
};
